import { render, staticRenderFns } from "./SmimeCertificateModal.vue?vue&type=template&id=65dec736&scoped=true"
import script from "./SmimeCertificateModal.vue?vue&type=script&lang=js"
export * from "./SmimeCertificateModal.vue?vue&type=script&lang=js"
import style0 from "./SmimeCertificateModal.vue?vue&type=style&index=0&id=65dec736&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dec736",
  null
  
)

export default component.exports